import Vue from 'vue';
import router from '../router';
import store from '../store';

window.JSBridge.invoke({
  bridgeName: 'getAppPermissions',
  data: {},
  callback: () => {},
});
window.JSBridge.invoke({
  bridgeName: 'handleAppPermission',
  listerEventsName: 'handleAppPermission',
  listerEventsCallback: (res) => {
    store.dispatch('getAuthList', res?.data);
    console.log('权限列表 =>>', res?.data);
  },
});

Vue.prototype.$has = function $has(code) {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (Object.prototype.toString.call(code) === '[object Object]') {
    const { name } = router.app.$route;
    if (name) {
      code = code[name];
    }
    if (code === true) code = 'ALWAYS_PASS';
  }
  return store.state.app.authList.some(item => code === 'ALWAYS_PASS' || item === code);
};
